import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import { CheckboxGroup } from '@/containers/SubscriptionFormPageNew/Components/ModalSaveAndSend/styled-components'
import useContact from '@/containers/SubscriptionFormPageNew/Components/Contact/useContact'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { useDispatch } from 'react-redux'
import useSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/useSaveButtons'

const ModalWhatsappConsent = () => {
  const dispatch = useDispatch()
  const { t, isEditable } = useSaveButtons({ setIsOpen: null })
  const { whatsappInteraction, country } = useContact()

  const handleChange = value => {
    dispatch(
      updateClientData({
        name: 'preferences',
        data: { whatsappInteraction: value },
      }),
    )
  }

  if (country !== 'de') return null

  return (
    <ModalSection>
      <CheckboxGroup>
        <SDCheckbox
          disabled={!isEditable}
          checked={whatsappInteraction}
          onChange={handleChange}
          labelPlacement={LABEL_PLACEMENT.right}
          label={t('subscriptionForm:header.modal_save_send.whatsapp_consent_text')}
        />
      </CheckboxGroup>
    </ModalSection>
  )
}

export default ModalWhatsappConsent
